import script from "./ProductTypeFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductTypeFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./ProductTypeFormDialog.vue?vue&type=style&index=0&id=ba2cf4e0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba2cf4e0"]])

export default __exports__